export default __webpack_public_path__ + "static/media/xsteak.4d94db6c.png";